import { Container } from '@cgs/wge';
import { CoordinateSystemInfoProvider, T_ICoordinateSystemInfoProvider } from '@cgs/common';
import { CollapseGameConfig } from '../../../reels_engine/free_fall_reels_engine/game_config/collapse_game_config';
import { AbstractGameConfig } from '../../../reels_engine/game_config/abstract_game_config';
import { T_BaseSlotGame } from '../../../type_definitions';
import { BaseSlotGame } from '../../base_slot_game';
import { IGameConfigProvider } from '../interfaces/i_game_config_provider';

export class CollapseGameConfigComponent implements IGameConfigProvider {
  private readonly _gameConfig: AbstractGameConfig;

  constructor(container: Container) {
    const game = container.resolve<BaseSlotGame>(T_BaseSlotGame);

    const coordinateSystemInfoProvider = container.resolve<CoordinateSystemInfoProvider>(
      T_ICoordinateSystemInfoProvider
    );

    this._gameConfig = new CollapseGameConfig(
      container,
      game.gameConfig,
      coordinateSystemInfoProvider.displayResolution
    );
  }

  public get gameConfig(): AbstractGameConfig {
    return this._gameConfig;
  }
}
